import React from 'react';
import {useSelector} from 'react-redux';
import {isAuthenticated} from '../store/AuthSlice';
import {getCurrentUser} from '../store/CommonSlice';
import LoginPage from '../view/security/LoginPage/LoginPage';

export const CheckLoginProxy = ({roles = [], children}) => {
    const authenticated = useSelector(isAuthenticated);
    const currentUser = useSelector(getCurrentUser);
    // const { checkUserRoles } = useContext(ApiContext);
    // console.log(currentUser);
    // console.log(authenticated);
    if (currentUser.uuid == '' || !authenticated) {
        return <LoginPage/>;
    } else {
        // return checkUserRoles(roles) ? children : <AccessDenied />
        return children;
    }
};
